// types
import type { StyledHeaderCellProps, StyledTableCellProps, StyledTableRowProps } from './types';

// libraries
import styled from 'styled-components';
import type { TableContainerProps } from '@mui/material/TableContainer';
import { Table, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const addUnit = (value: string | number | undefined): string | undefined => {
  if (value === undefined) return undefined;

  return typeof value === 'number' ? `${value}px` : value;
};

export const StyledTableWrapper = styled.div`
  position: relative;
  width: 100%;

  .total {
    position: absolute;
    top: -30px;
    right: 0;
  }

  .buttonWrap {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 6px;
      width: 32px;
      height: 32px;
      border-radius: 4px;
      border: 0.5px solid var(--color-pale-gray);
      background: var(--color-off-white);
    }
  }
`;

export const StyledTableContainer = styled(TableContainer)<TableContainerProps>`
  height: fit-content;
  box-shadow: none;
  overflow-x: auto;
  width: 100%;
  box-shadow: none !important;

  table {
    min-width: max-content;
  }

  .MuiPaper-root {
    box-shadow: none !important;
  }

  .MuiTableCell-root {
    padding: 0;
    line-height: unset;
  }
`;

export const StyledTable = styled(Table)`
  width: 100%;
  border-spacing: 0;
`;

export const StyledTableHead = styled(TableHead)`
  /* position: sticky;
  top: 0; */

  tr {
    th {
      height: 40px;
      border-top: 0.5px solid var(--color-pale-gray);
      border-bottom: 0.5px solid var(--color-pale-gray);
      background: var(--color-off-white);
      text-align: center;
    }
  }
`;

export const StyledHeaderCell = styled(TableCell)<StyledHeaderCellProps>`
  height: 40px;
  padding: 0;
  font-weight: 600;
  color: var(--color-table-header);
  white-space: nowrap;
  background: var(--color-off-white);
  text-align: center;
  border-top: 0.5px solid var(--color-pale-gray);
  border-bottom: 0.5px solid var(--color-pale-gray);
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;

  position: sticky;
  top: 0;

  ${(props) =>
    props.$width &&
    `
    width: ${addUnit(props.$width)} !important;
    max-width: ${addUnit(props.$width)} !important;
  `}
  ${(props) => props.$minWidth && `min-width: ${addUnit(props.$minWidth)} !important;`}

  &:hover {
    background-color: ${(props) =>
      props.$sortable ? 'var(--color-ice-blue)' : 'var(--color-off-white)'};
  }
`;

export const StyledTableRow = styled(TableRow)<StyledTableRowProps>`
  &:hover {
    td {
      color: var(--color-primary-blue);
      background-color: var(--color-off-white);

      > * {
        color: var(--color-primary-blue);
        background-color: var(--color-off-white);
      }
    }
  }

  ${(props) =>
    props.$isSelected &&
    `
    td {
      color: var(--color-primary-blue);
      background-color: var(--color-off-white);

      > * {
      color: var(--color-primary-blue);
      background-color: var(--color-off-white)
    }
    }
  `}

  ${(props) =>
    props.$isGroupHeader &&
    `
    background-color: var(--color-background-light, #f5f5f5);
    
    .group-header-cell {
      font-weight: 500;
    }
    
    &:hover {
      background-color: var(--color-background-hover, #eeeeee);
      
      td {
        color: var(--color-primary-blue);
      }
    }
  `}
`;

export const StyledTableCell = styled(TableCell)<StyledTableCellProps>`
  height: 40px;
  padding: 0;
  background: var(--color-white);
  text-align: center;
  cursor: pointer;
  color: var(--color-medium-gray);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  ${(props) =>
    props.ellipsis &&
    `
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}

  ${(props) =>
    props.align &&
    `
    text-align: ${props.align};
  `}

  ${(props) =>
    props.selected &&
    `
    color: var(--color-primary-blue);
    background-color: var(--color-off-white);

    > * {
      color: var(--color-primary-blue);
      background-color: var(--color-off-white)
    }
  `}

  &:hover {
    color: var(--color-primary-blue) !important;
    background-color: var(--color-off-white) !important;
  }

  &.selection-column {
    width: 32px;
    position: sticky;
    left: 0;
    z-index: 1;
  }
`;
